import * as React from "react";
import { Component } from "react";
import MainLayout from "../../layouts/MainLayout";
import Table from "../../components/Table";
import { __, getURLParam, mapStateToProps, setTableParams, getLocalized } from "../../core/utils";
import { createSidebar, createSuperadminSidebar } from "../../redux/actions/general/sidebar";
import { listActiveModules } from "../../redux/actions/general/active_modules";
import Tooltip from "../../components/Tooltip";
import * as _ from "lodash";
import { setPlusActions } from "../../redux/actions/general/plus";
import DeleteIcon from "../../assets/images/delete-15x15.svg";
import { hideAlertbox, showAlertbox } from "../../redux/actions/general/alertbox";
import { setNotification } from "../../redux/actions/general/notification";
import UnitsFlyout from "../../flyouts/superadmin/units/UnitsFlyout";
import {
	deleteUnits,
	listUnits,
	readUnit,
} from "../../redux/actions/table/superadmin/units";
import { listLocalization } from "../../redux/actions/localization";

@mapStateToProps(state => ({
	superadmin: state.auth.superadmin,
	table: state.table["superadmin_units"],
	auth: state.auth,
	application_language_id: state.auth.language_id,
}))
class Units extends Component {
	constructor(props) {
		super(props);

		this.state = {
			preview: null,
		};
	}

	componentDidMount() {
		listActiveModules();
		createSuperadminSidebar(); //don't forget to add new routes in sidebar.js

		const { superadmin } = this.props;

		superadmin.add_unit && setPlusActions([{
			title: "Add unit",
			onClick: () => setTableParams('superadmin_units', {
				add_unit_wizard: true
			})
		}]);
	}

	componentDidUpdate(prevProps) {
		if (this.props.table.clicked_row && this.props.table.clicked_row !== prevProps.table.clicked_row) {
			if (!prevProps.table.clicked_row) {
				this.setState({ preview: undefined });
			}

			readUnit(this.props.table.clicked_row).then(({ response }) => {
				this.setState({ preview: response.data });
			});
		}
	}

	render() {
		const { superadmin, application_language_id } = this.props;

		let columns = [
			{
				key: "name",
				name: "Name",
				required: true,
				value: name => {
					const localizedName = getLocalized(name, application_language_id);
					return <Tooltip text={localizedName}>{localizedName}</Tooltip>;
				}
			},
			{
				key: "symbol",
				name: "Symbol",
				required: true,
				value: symbol => {
					const localizedSymbol = getLocalized(symbol, application_language_id);
					return <Tooltip text={localizedSymbol}>{localizedSymbol}</Tooltip>;
				}
			},
			{
				key: "description",
				name: "Description",
				required: true,
				value: description => {
					const localizedDescription = getLocalized(description, application_language_id);
					return <Tooltip text={localizedDescription}>{localizedDescription}</Tooltip>;
				}
			},
			{
				key: "unit_group",
				name: "Unit Group",
				required: true,
				width: 150,
				value: unit_group => (
					<Tooltip text={unit_group}>{unit_group}</Tooltip>
				)
			},
			{
				key: "coefficient",
				name: "Coefficient",
				required: true,
				width: 100,
				value: coefficient => {
					coefficient = parseFloat(coefficient).toFixed(2);

					return (
						<Tooltip text={coefficient}>{coefficient}</Tooltip>
					);
				}
			},
		];

		const singleActions = (unit_id) => {
			return [
				<Tooltip text="Delete selected unit" key={_.uniqueId()}>
					<DeleteIcon
						onClick={e => {
							e.stopPropagation();

							showAlertbox({
								color: "red",
								title: __('general.alert.are-you-sure'),
								description: "Do you really want to delete the selected unit?\nThis process cannot be undone.",
								buttons: [
									{
										color: 'lightGray',
										text: __('general.alert.no-close'),
										onClick: 'close'
									},
									{
										color: 'gray',
										text: __('general.alert.yes-delete'),
										onClick: () => {
											deleteUnits([unit_id]).then(() => {
												hideAlertbox();

												setNotification("The selected unit has been deleted.");
												listUnits();

												listLocalization();

												setTableParams('superadmin_units', {
													actioned_row: undefined
												});
											});
										},
									}
								]
							})
						}}
					/>
				</Tooltip>
			];
		};

		const groupActions = (units_ids) => [
			<Tooltip text="Delete selected units" key={_.uniqueId()}>
				<DeleteIcon
					onClick={e => {
						e.stopPropagation();

						showAlertbox({
							color: "red",
							title: __('general.alert.are-you-sure'),
							description: "Do you really want to delete these units?\nThis process cannot be undone.",
							buttons: [
								{
									color: 'lightGray',
									text: __('general.alert.no-close'),
									onClick: 'close'
								},
								{
									color: 'gray',
									text: __('general.alert.yes-delete'),
									onClick: () => {
										deleteUnits(units_ids).then(() => {
											hideAlertbox();

											setNotification("The selected units have been deleted.");
											listUnits();

											listLocalization();

											setTableParams('superadmin_units', {
												selected_rows: []
											});
										});
									},
								}
							]
						})
					}}
				/>
			</Tooltip>
		];

		const preview = (
			<UnitsFlyout
				data={this.state.preview}
				readAction={unit_id => {
					return new Promise(resolve => {
						readUnit(getURLParam('id') || unit_id).then(({ response }) => {
							this.setState({ preview: response.data });

							resolve(response);
						});
					});
				}}
			/>
		);

		return (
			<Table
				listAction={listUnits}
				name="superadmin_units"
				groupActions={superadmin.delete_unit && groupActions}
				singleActions={superadmin.delete_unit && singleActions}
				title={__("modules.submodules.title.units")}
				preview={this.state.preview ? preview : []}
				columns={columns}
			/>
		);
	}
}

export default Units;
